<template>
    <div
        class="cell py-1 flex items-center justify-center border-gray-200 dark:border-gray-600 whitespace-nowrap min-w-[11rem] text-xs"
        :class="[background, { 'min-w-[18rem]': isImportModal }]"
    >
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        background: {
            type: Array | Object | String,
            default: 'bg-white hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-800 text-xs',
        },
        isImportModal: {
            type: Boolean,
            default: false,
            required: false
        }
    },
};
</script>
